<button
  type="button"
  class="topbar-menu__trigger"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-expanded]="open()"
  [attr.aria-haspopup]="true"
  (click)="toggle()">
  <ng-content select="[pulseTopbarMenuTrigger]" />
  <i class="topbar-menu__caret fa-solid fa-chevron-down" aria-hidden="true"></i>
</button>

@if (open()) {
  <div [class]="panelHostClass()">
    <ng-content />
  </div>
}
